
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import { C as CollapseTransition } from './collapse-transition-mixin.js';
import uniqueId from 'lodash/uniqueId';

var script = {
  name: 'PendoCollapseItemCard',
  components: {
    PendoIcon
  },
  inject: ['$collapse'],
  props: {
    title: {
      type: String,
      required: true
    },
    allowCollapse: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    if (this.$collapse.$el.parentNode.classList[0] === 'pendo-card__body') {
      this.$collapse.$el.parentNode.style.padding = 0;
    }
  }

};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-collapse-item__title"
  }, [_vm._t("prefix"), _vm._v(" "), _vm._t("title", [_c('div', {
    staticClass: "pendo-collapse-item__title-inner"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _vm._t("suffix", [_vm.allowCollapse ? _c('pendo-icon', {
    staticClass: "pendo-collapse-item__suffix-icon",
    attrs: {
      "type": "chevron-down",
      "size": "18"
    }
  }) : _vm._e()])], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "card-trigger.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var CardTrigger = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'PendoDetailsCollapseTrigger',
  components: {
    PendoIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    }
  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-collapse-item__title"
  }, [_vm._t("prefix"), _vm._v(" "), _vm._t("title", [_c('div', {
    staticClass: "pendo-collapse-item__title-inner"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _vm._t("suffix", [_c('pendo-icon', {
    staticClass: "pendo-collapse-item__suffix-icon",
    attrs: {
      "type": _vm.expanded ? 'minus-square' : 'plus-square',
      "size": "14"
    }
  })])], 2);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "details-trigger.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var DetailsTrigger = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

var script$2 = {
  name: 'CollapseItem',
  components: {
    CardTrigger,
    CollapseTransition,
    DetailsTrigger,
    PendoIcon
  },
  inject: ['$collapse'],
  props: {
    collapsible: {
      type: Boolean,
      default: true
    },
    name: {
      type: [String, Number],

      default() {
        return this._uid;
      }

    },
    title: {
      type: String,
      default: null
    },
    activeTitle: {
      type: String,
      default: null
    },
    prefixIcon: {
      type: Object,
      default: null
    },
    suffixIcon: {
      type: [Object, Boolean],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isFocused: false,
      isClick: false,
      id: uniqueId()
    };
  },

  computed: {
    panelPrefixIcon() {
      return _objectSpread({}, this.$collapse.panelHeaderProps.prefixIcon, this.prefixIcon);
    },

    panelSuffixIcon() {
      return _objectSpread({}, this.suffixIcon !== false && this.allowCollapse && {
        type: 'chevron-down',
        size: '14px',
        stroke: '#BABCC5'
      }, this.$collapse.panelHeaderProps.suffixIcon, this.suffixIcon);
    },

    titleContent() {
      if (this.isExpanded && this.activeTitle) {
        return this.activeTitle;
      }

      return this.title;
    },

    isExpanded() {
      return this.$collapse.model.indexOf(this.name) > -1;
    },

    allowCollapse() {
      return this.$collapse.forceAlwaysOpen && this.$collapse.forceAlwaysOpen.indexOf(this.name) === -1;
    },

    showPrefixIcon() {
      if (this.$slots.title) {
        return false;
      }

      return this.panelPrefixIcon && this.panelPrefixIcon.type;
    },

    showSuffixIcon() {
      if (!this.allowCollapse) {
        return false;
      }

      if (this.type) {
        return false;
      }

      return this.panelSuffixIcon && this.panelSuffixIcon.type;
    }

  },

  created() {
    if (this.expanded) {
      this.$collapse.handlePanelClick(this.name);
    }
  },

  methods: {
    handleFocus() {
      setTimeout(() => {
        if (!this.isClick) {
          this.isFocused = true;
        } else {
          this.isClick = false;
        }
      }, 50);
    },

    handleHeaderClick() {
      if (this.allowCollapse && !this.disabled && this.collapsible) {
        this.$collapse.handlePanelClick(this.name);
        this.isFocused = false;
        this.isClick = true;
      }

      this.$emit('click', this.name);
    },

    handleEnterKeydown() {
      if (this.allowCollapse && !this.disabled && this.collapsible) {
        this.$collapse.handlePanelClick(this.name);
      }
    }

  }
};

const __vue_script__$2 = script$2;

var __vue_render__$2 = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-collapse-item",
    class: [(_obj = {}, _obj["pendo-collapse-item--" + _vm.type] = _vm.type, _obj['pendo-collapse-item--collapsible'] = _vm.collapsible, _obj['is-expanded'] = _vm.isExpanded, _obj['is-always-open'] = !_vm.allowCollapse, _obj['is-disabled'] = _vm.disabled, _obj)],
    attrs: {
      "id": "" + _vm.name
    }
  }, [_c('div', {
    attrs: {
      "role": "tab",
      "aria-expanded": _vm.isExpanded,
      "aria-controls": "pendo-collapse-content-" + _vm.id,
      "aria-describedby": "pendo-collapse-content-" + _vm.id
    }
  }, [_c('div', {
    staticClass: "pendo-collapse-item__header",
    class: {
      'is-focused': _vm.isFocused,
      'is-expanded': _vm.isExpanded
    },
    attrs: {
      "id": "pendo-collapse-head-" + _vm.id,
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.handleHeaderClick,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"]) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        $event.stopPropagation();
        return _vm.handleEnterKeydown($event);
      },
      "focus": _vm.handleFocus,
      "blur": function ($event) {
        _vm.isFocused = false;
      }
    }
  }, [_vm.type === 'card' ? _c('card-trigger', {
    attrs: {
      "title": _vm.titleContent,
      "disabled": _vm.disabled,
      "allow-collapse": _vm.allowCollapse
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slot) {
      return {
        key: slot,
        fn: function (scope) {
          return [_vm._t(slot, null, null, scope)];
        }
      };
    })], null, true)
  }) : _vm._e(), _vm._v(" "), _vm.type === 'details' ? _c('details-trigger', {
    attrs: {
      "expanded": _vm.isExpanded,
      "title": _vm.titleContent
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slot) {
      return {
        key: slot,
        fn: function (scope) {
          return [_vm._t(slot, null, null, scope)];
        }
      };
    })], null, true)
  }) : _vm._e(), _vm._v(" "), !_vm.type ? [_vm._t("prefix", [_vm.showPrefixIcon ? _c('pendo-icon', _vm._b({
    staticClass: "pendo-collapse-item__prefix-icon"
  }, 'pendo-icon', _vm.panelPrefixIcon, false)) : _vm._e()]), _vm._v(" "), _vm._t("title", [!_vm.type ? _c('div', {
    staticClass: "pendo-collapse-item__title"
  }, [_vm._v("\n                        " + _vm._s(_vm.titleContent) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _vm._t("suffix", [_vm.showSuffixIcon ? _c('pendo-icon', _vm._b({
    staticClass: "pendo-collapse-item__suffix-icon"
  }, 'pendo-icon', _vm.panelSuffixIcon, false)) : _vm._e()])] : _vm._e()], 2)]), _vm._v(" "), _c('collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isExpanded,
      expression: "isExpanded"
    }],
    staticClass: "pendo-collapse-item__wrap",
    attrs: {
      "id": "pendo-collapse-content-" + _vm.id,
      "role": "tabpanel",
      "aria-hidden": !_vm.isExpanded,
      "aria-labelledby": "pendo-collapse-head-" + _vm.id
    }
  }, [_c('div', {
    staticClass: "pendo-collapse-item__content"
  }, [_vm._t("default")], 2)])])], 1);
};

var __vue_staticRenderFns__$2 = [];
const __vue_inject_styles__$2 = undefined;
const __vue_scope_id__$2 = undefined;
const __vue_is_functional_template__$2 = false;

function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-collapse-item.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoCollapseItem = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2);

export default PendoCollapseItem;
